<template>
  <b-modal v-model="visible" title="Tải ảnh xác thực" hide-footer centered>
    <!-- Upload Images -->
    <div class="d-flex flex-wrap">
      <UploadMultiple2
        :title="'Ảnh xác thực *'"
        :maxFile="100"
        titleTag="h2"
        :uploadToApi="false"
        :isDragging="true"
        titleClass="form-inner-heading"
        ref="uploadImages"
        @change="handleChangeImg"
      />
    </div>

    <!-- Footer -->
    <div class="d-flex justify-content-end mt-4">
      <b-button variant="outline-danger" class="mr-2" @click="closeModal" :disabled="isLoading">
        <b-icon icon="x" scale="2" aria-hidden="true" />
        Thoát
      </b-button>
      <b-button variant="outline-primary" @click="handleSubmit" :disabled="isLoading || !hasImages">
        <b-spinner small v-show="isLoading" />
        <b-icon icon="check" scale="2" aria-hidden="true" v-show="!isLoading" />
        Tải và Cập nhật giao hàng thành công
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import UploadMultiple2 from '@/components/cskh/UploadMultiple2.vue'
  import { LeadsService } from '@/services/lead.service'
  export default {
    name: 'PopupUpdateImgShipping',
    components: {
      UploadMultiple2,
    },
    data() {
      return {
        visible: false,
        isLoading: false,
        isUpdated: false,
        leadId: null,
        shippingLeadId: null,
        fileUploads: null,
      }
    },
    computed: {
      hasImages() {
        return (this.fileUploads || 0) !== 0
      },
    },
    methods: {
      handleChangeImg(files) {
        this.fileUploads = files.length
      },
      closeModal() {
        this.visible = false
        this.stateUpload = false
      },
      openModal(leadId, shippingLeadId) {
        this.leadId = leadId
        this.shippingLeadId = shippingLeadId
        this.visible = true
        return new Promise(resolve => {
          this.resolveFn = resolve
        })
      },
      async handleSubmit() {
        try {
          this.isLoading = true
          const uploadedImages = await this.$refs.uploadImages.saveData()
          const payload = {
            imageUrls: uploadedImages,
            leadId: this.leadId,
            shippingLeadId: this.shippingLeadId,
          }
          const response = await LeadsService.updateInforShippping(payload)
          if (response.code === 1000) {
            this.resolveFn(true)
            this.closeModal()
          } else {
            this.resolveFn(false)
            this.showFailMx(response.message)
          }
        } catch (e) {
          this.showFailMx(e.message ?? e)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>
